const AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
};

const AndroidImportance = {
  HIGH: 4,
  DEFAULT: 3,
  LOW: 2,
  MIN: 1,
  NONE: 0,
};

const EventType = {
  DISMISSED: 0,
  PRESS: 1,
  ACTION_PRESS: 2,
};

const TriggerType = {
  TIMESTAMP: 0,
  INTERVAL: 1,
};

const TimestampTrigger = {};

const Notifee = {
  displayNotification: async () => {},
  createChannel: async () => 'default',
  onForegroundEvent: () => () => {},
  onBackgroundEvent: () => {},
  getInitialNotification: async () => null,
  requestPermission: async () => ({ authorizationStatus: 1 }),
  getNotificationSettings: async () => ({ authorizationStatus: 0 }),
  cancelNotification: async () => {},
  cancelAllNotifications: async () => {},
  AndroidImportance,
  EventType,
  AuthorizationStatus,
  TriggerType,
  TimestampTrigger,
};

module.exports = Notifee;
module.exports.default = Notifee;
module.exports.AndroidImportance = AndroidImportance;
module.exports.EventType = EventType;
module.exports.AuthorizationStatus = AuthorizationStatus;
module.exports.TriggerType = TriggerType;
module.exports.TimestampTrigger = TimestampTrigger;
module.exports.getNotificationSettings = Notifee.getNotificationSettings;
